import { createModalExecutor } from '@organisms/actions/createModalExecutor';
import { ICreateAttachVersionProps } from './ICreateAttachVersionProps';
import { CreateAttachVersionModal } from './CreateAttachVersionModal';

export const CreateAttachVersionExecutor = createModalExecutor<ICreateAttachVersionProps>({
    modal: CreateAttachVersionModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, parentId, rowData, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: parentId ?? '',
        attachId: objId,
        rowData: rowData,
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
